var md = new MobileDetect(window.navigator.userAgent);

var site = {
	rate : 1000,
    timeout : 6000
};

Object.size = function(obj) {
	var size = 0, key;
	for (key in obj) {
		if (obj.hasOwnProperty(key)){
			size++;
		}
	}
	return size;
};

(function($) {

    document.ontouchmove = function (e) {
      e.preventDefault();
    }

    // Enable scrolling.
    document.ontouchmove = function (e) {
      return true;
    }
    
    /*
    *
    * Banner module
    *****************************************************************************
    *
    * Preloading banner module with 'src-set' support and object-fit
    *
    *****************************************************************************/

    var $cycle;

    objectFitImages('.slide img');

    var $splash = $('.splash');
    var $wrapper = $('.banner-wrap');
    var $slider = $('.banner');
    var $preloader = $('.banner-preloader');

    // $wrapper.append('<div class="slideshow-loader"></div>');
    // $wrapper.find('.slideshow-loader').hide().fadeIn();

    var totalImages = $('.banner-preloader img').size();

    NProgress.start();

    $preloader.imagesLoaded()
    .always(function(){

        NProgress.done();

        $splash.delay(3000).fadeOut('slow');

        $cycle = $slider.cycle({
            speed : site.rate,
            timeout : site.timeout,
            swipe : true,
            slides : "> .slide",
            fx : 'fade',
            swipeFx :  'fade',
            captionTemplate: '{{slideNum}} &mdash; {{slideCount}}'
        });
        

        $cycle.on( 'cycle-before', function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {
            if( $(incomingSlideEl).data('reverse') ){
                $('body').addClass('reverse');
            }else{
                $('body').removeClass('reverse');
            }
        });

        var $navbar = $('.info-overlay'),
            navOpen;

        $('.info-link').on('click',function(){
            navOpen = true;
            // console.log('fewf');
            TweenMax.to($navbar,1,{ autoAlpha:1 });
            $cycle.cycle('pause');
        });

        $('.btn-close').on('click',function(){
            navOpen = false;
            TweenMax.to($navbar,1,{ autoAlpha:0 });
            $cycle.cycle('resume');
        });

    })
    .progress( function( instance, image ) {

        if(image.isLoaded) {
            $(image.img).addClass('loaded');

            var loadedImages = $('.banner-preloader img.loaded').size(); 
            var p = loadedImages / totalImages;
            console.log(p);

            // NProgress.set(p);
            NProgress.inc();

        }

    });

    
})(jQuery);